/** 美的平台流量-数据埋点 */
import axios from 'axios';
import { getSession, setSession } from '@/utils';
/**
* 页面埋点
*
*/
// const bigdataToken = JSON.parse(sessionStorage.getItem('BigdataToken'));
export async function detailMsgs(dataInit = {}, childModuleName = 'cmms') {
  let data = {};
  if (dataInit && dataInit.model_name1) {
    // 直接传入数据
    data = dataInit;
  } else {
    data = navNameList(dataInit);
  }
  // 一些必填参数
  window.moduleName = 'C-CMS';// 产品名称，必填
  window.childModuleName = childModuleName;// 子产品名称，不是必填项
  if (process.env.ENV_CONFIG === 'prod') {
    window.appSecrect = 'ju22mk-bh198-nuh190-bf1ma9-bjyg17'; // 生产产品秘钥
  } else {
    window.appSecrect = 'mu199-hn178-ah1if7-a1ji189-my90mh';// 产品密钥，必填
  }

  window.appName = 'C-CMS';// 部门或产品标识，用于获取令牌、校验令牌，必填
  window.userName = (getSession('user') && getSession('user').mip) || '';// 用户MIP，必填

  if (!window.userName) return;

  const times = (new Date()).getTime() - (window.EXPIRE || 0);
  // 过期时间到了，更新令牌
  if (!window.EXPIRE || times > 0) {
    await getBigdataToken().then(res => {
      setSession('BigdataToken', JSON.stringify(res.data.data));
      window.TOKEN = res.data.data.token;
      window.EXPIRE = res.data.data.expire;
    });
  }

  const params = {
    userName: window.userName,
    random_key: Math.random(),
    model_name1: data.model_name1 || '',
    model_name2: data.model_name2 || '',
    model_name3: data.model_name3 || '',
    model_name4: data.model_name4 || '',
    model_button1: data.model_button1 || '',
    model_button2: data.model_button2 || '',
    model_button3: data.model_button3 || '',
    model_button4: data.model_button4 || '',
    // token: bigdataToken.token,
    // time: bigdataToken.expire,
  };
  // console.log('页面埋点平台88888：', params, '平台埋点地址：', window.ip, window.EXPIRE, data.model_name1);
  if (data.model_name1) {
    clickMsgs(params); // 功能统计
  } else {
    mainMsgs(); // 登录统计
  }
}

export function clickMsgs(params) {
  // 登录
  window.detailMsg && window.detailMsg(
    params.userName,
    params.random_key,
    params.model_name1,
    params.model_name2,
    params.model_name3,
    params.model_name4,
    params.model_button1,
    params.model_button2,
    params.model_button3,
    params.model_button4,
    window.TOKEN,
    window.EXPIRE,
  );
}

export function mainMsgs() {
  // 登录
  window.mainMsg(
    window.userName,
    window.TOKEN,
    window.EXPIRE,
  );
}

// 获取埋点所需要的token和时间戳
export function getBigdataToken() {
  if (process.env.ENV_CONFIG === 'prod') {
    window.ip = 'https://bigdataservice.midea.com';
  } else {
    window.ip = 'http://testbigdataservice.midea.com';
  }
  return axios({
    url: window.ip + '/bigdatatoken/api/1.0.1/getToken',
    method: 'post',
    params: {
      appSecrect: window.appSecrect,
      appName: window.appName,
      userName: window.userName,
    },
  });
}

// 菜单属性
export const navNameList = (to) => {
  let param = {};
  if (to && to.matched) {
    let nav2Init = to.matched[0] || {};
    let nav1Type = (typeof (nav2Init.name) === 'string') && nav2Init.name.split('__')[0];
    switch (nav1Type) {
    case 'potential':
      param['model_name1'] = '潜在会员';
      break;
    case 'vip':
      param['model_name1'] = '会员管理';
      break;
    case 'market':
      param['model_name1'] = '营销中心';
      break;
    case 'data':
      param['model_name1'] = '数据分析';
      break;
    case 'sys':
      param['model_name1'] = '系统设置';
      break;
    default:
      param['model_name1'] = '首页';
    }
    if ((typeof (nav2Init.name) === 'string') && nav2Init.name.split('__').length === 2) {
      param['model_name2'] = nav2Init.meta.label;
      param['model_name3'] = to.matched[1].meta.label;
    }

  }
  // console.log('菜单属性:', param);
  return param;
};

export function getScript(src) {
  document.write(`<script async src=${src} type="text/javascript"></script>`);
};
